import { useTranslation } from '@pancakeswap/localization'
import { Swap } from '@pancakeswap/widgets-internal'
import { ChainId } from '@pancakeswap/chains'
import { Button, Flex, Text } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { ErrorBoundary } from 'components/ErrorBoundary'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { EXCHANGE_HELP_URLS } from 'config/constants'

const ErrorCard = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  max-width: 420px;
  margin: 80px auto;
  padding: 40px 32px;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.backgroundAlt};
  box-shadow: 0 16px 40px -16px rgba(0, 0, 0, 0.6);
`

const TradeErrorFallback = () => (
  <ErrorCard>
    <Text fontSize="20px" bold>
      Something went wrong
    </Text>
    <Text color="textSubtle" fontSize="14px">
      This page hit an unexpected error. Reloading usually fixes it.
    </Text>
    <Button mt="8px" onClick={() => window.location.reload()}>
      Reload page
    </Button>
  </ErrorCard>
)

const Page: React.FC<
  React.PropsWithChildren<{
    removePadding?: boolean
    hideFooterOnDesktop?: boolean
    noMinHeight?: boolean
    helpUrl?: string
  }>
> = ({
  children,
  removePadding = false,
  hideFooterOnDesktop = false,
  noMinHeight = false,
  helpUrl = EXCHANGE_HELP_URLS,
  ...props
}) => {
    const { t } = useTranslation()
    const { chainId } = useActiveChainId()
    const isScroll = chainId === ChainId.PULSE
    const externalText = isScroll ? t('Bridge assets to Scroll Chain') : ''
    const externalLinkUrl = isScroll ? 'https://bridge.pre-prod.v3-cbr.pages.dev/' : ''

    return (
      <Swap.Page
        removePadding={removePadding}
        noMinHeight={noMinHeight}
        hideFooterOnDesktop={hideFooterOnDesktop}
        helpUrl={helpUrl}
        externalText={externalText}
        externalLinkUrl={externalLinkUrl}
        {...props}
      >
        <ErrorBoundary fallback={<TradeErrorFallback />}>{children}</ErrorBoundary>
      </Swap.Page>
    )
  }

export default Page
